(function () {
  'use strict';
  function init() {
    var main = document.getElementById('main-image');
    if (!main || main.dataset.kopdReady) return;
    main.dataset.kopdReady = 'true';
    var gallery = main.closest('.rrr-gallery');
    var buttons = Array.from(gallery.querySelectorAll('[data-gallery-src]'));
    if (!buttons.length) return;
    var index = 0;
    var pending = 0;
    var cached = Object.create(null);
    function warmNext() {
      if (buttons.length < 2) return;
      var src = buttons[(index + 1) % buttons.length].dataset.gallerySrc;
      if (cached[src]) return;
      cached[src] = true;
      var image = new Image();
      image.decoding = 'async';
      image.src = src;
    }
    function show(next) {
      index = (next + buttons.length) % buttons.length;
      var target = index;
      var request = ++pending;
      var src = buttons[index].dataset.gallerySrc;
      var image = new Image();
      main.classList.add('loading');
      image.onload = function () {
        if (request !== pending) return;
        main.removeAttribute('srcset');
        main.src = src;
        main.classList.remove('loading');
        buttons.forEach(function (button, i) {
          button.classList.toggle('active', i === target);
          button.setAttribute('aria-pressed', i === target ? 'true' : 'false');
        });
        var count = gallery.querySelector('#current-img');
        if (count) count.textContent = String(target + 1);
        warmNext();
      };
      image.onerror = function () {
        if (request === pending) main.classList.remove('loading');
      };
      image.src = src;
    }
    buttons.forEach(function (button, i) { button.addEventListener('click', function () { show(i); }); });
    gallery.querySelectorAll('[data-gallery-step]').forEach(function (button) {
      button.addEventListener('click', function () { show(index + Number(button.dataset.galleryStep)); });
    });
    var start = null;
    var container = gallery.querySelector('#main-image-container');
    container.addEventListener('touchstart', function (event) { start = event.touches[0].clientX; }, {passive: true});
    container.addEventListener('touchend', function (event) {
      if (start === null) return;
      var delta = event.changedTouches[0].clientX - start;
      start = null;
      if (Math.abs(delta) > 50) show(index + (delta < 0 ? 1 : -1));
    }, {passive: true});
    // Start at most one next-image request, after the primary image is ready.
    if (main.complete) warmNext();
    else main.addEventListener('load', warmNext, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
